import React, { useState } from 'react';
import { IconButton, Badge, Drawer, Box } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import NotificationDropdown from './NotificationDropdown';
import NotificationSettingsPanel from './NotificationSettingsPanel';

/**
 * NotificationBell Component
 * Displays bell icon with badge count and handles drawer toggle
 */
function NotificationBell({ unreadCount, notifications, onMarkAsRead, onMarkAllAsRead, onNotificationClick, onRefresh, onDeleteAll, onDeleteNotification, loading, onOpen }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentPanel, setCurrentPanel] = useState('notifications'); // 'notifications' or 'settings'

  const handleOpen = () => {
    setDrawerOpen(true);
    setCurrentPanel('notifications');
    // Refresh notifications when drawer opens
    if (onOpen) {
      onOpen();
    }
  };

  const handleClose = () => {
    setDrawerOpen(false);
    setCurrentPanel('notifications');
  };

  const handleOpenSettings = () => {
    setCurrentPanel('settings');
  };

  const handleBackToNotifications = () => {
    setCurrentPanel('notifications');
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        data-notification-bell="true"
        sx={{
          width: 48,
          height: 48,
          color: drawerOpen ? 'primary.main' : 'inherit',
          transition: 'all 0.2s',
          padding: 0,
          '&:hover': {
            backgroundColor: 'action.hover',
          }
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.65rem',
              height: 18,
              minWidth: 18,
              padding: '0 4px',
              fontWeight: 600
            }
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 420 },
          }
        }}
      >
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          {currentPanel === 'notifications' ? (
            <NotificationDropdown
              notifications={notifications}
              onMarkAsRead={onMarkAsRead}
              onMarkAllAsRead={onMarkAllAsRead}
              onNotificationClick={(notification) => {
                onNotificationClick(notification);
              }}
              onRefresh={onRefresh}
              onDeleteAll={onDeleteAll}
              onDeleteNotification={onDeleteNotification}
              onOpenSettings={handleOpenSettings}
              onClose={handleClose}
              loading={loading}
            />
          ) : (
            <NotificationSettingsPanel 
              onBack={handleBackToNotifications}
              onClose={handleClose}
            />
          )}
        </Box>
      </Drawer>
    </>
  );
}

export default NotificationBell;
